import {
  BpCardComponent, BpCardBodyComponent, BpCardSubtitleDirective, BpCardTitleDirective, BpCardTextDirective,
  BpCardHeaderComponent, BpCardFooterComponent, BpCardImageDirective, BpCardImageOverlayComponent
} from './card';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

const DECLARES = [
  BpCardComponent,
  BpCardBodyComponent,
  BpCardTitleDirective,
  BpCardSubtitleDirective,
  BpCardTextDirective,
  BpCardHeaderComponent,
  BpCardFooterComponent,
  BpCardImageDirective,
  BpCardImageOverlayComponent
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: DECLARES,
  exports: DECLARES
})
export class BpCardModule {
}
